import { render, staticRenderFns } from "./directSend.vue?vue&type=template&id=e8895da2&scoped=true&"
import script from "./directSend.vue?vue&type=script&lang=js&"
export * from "./directSend.vue?vue&type=script&lang=js&"
import style0 from "./directSend.vue?vue&type=style&index=0&id=e8895da2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8895da2",
  null
  
)

export default component.exports